export function normalizeWishlistProductId(id) {
  if (id == null) return '';
  if (typeof id === 'object') {
    return String(id._id ?? id.id ?? '');
  }
  return String(id);
}

export function isProductInWishlist(selectedWishItems, productId) {
  const normalized = normalizeWishlistProductId(productId);
  if (!normalized) return false;
  return selectedWishItems.some((item) => normalizeWishlistProductId(item) === normalized);
}

export function extractWishlistProductIds(wishlistItems) {
  if (!Array.isArray(wishlistItems)) return [];
  return wishlistItems
    .map((item) => normalizeWishlistProductId(item?.productId?.id ?? item?.productId))
    .filter(Boolean);
}
